import {
  Directive,
  ElementRef,
  HostListener,
  forwardRef
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Directive({
  selector: '[appRutFormat]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RutFormatDirective),
      multi: true
    }
  ]
})
export class RutFormatDirective implements ControlValueAccessor {
  private onChange: (value: any) => void = () => { };
  private onTouched: () => void = () => { };

  constructor(private el: ElementRef<HTMLInputElement>) { }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    let input = event.target as HTMLInputElement;
    // Solo números y K
    let raw = input.value.replace(/[^0-9kK]/g, '');
    if (raw.length > 9) raw = raw.substring(0, 9);
    // Eliminar K si no se encuentra al final
    raw = raw.replace(/(?!^)[kK](?=.*\d)/g, '');
    const formatted = this.formatRut(raw);

    input.value = formatted;
    this.onChange(formatted); // 🔥 Esto enlaza con [(ngModel)]
  }

  @HostListener('blur')
  onBlur() {
    this.onTouched();
  }

  writeValue(value: any): void {
    const formatted = this.formatRut(value || '');
    this.el.nativeElement.value = formatted;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  private formatRut(value: string): string {
    if (!value) return '';
    const clean = value.replace(/[^0-9kK]/g, '').toUpperCase();
    if (clean.length <= 1) return clean;

    const body = clean.slice(0, -1);
    const dv = clean.slice(-1);
    const reversed = body.split('').reverse();
    const chunks = [];

    for (let i = 0; i < reversed.length; i += 3) {
      chunks.push(reversed.slice(i, i + 3).reverse().join(''));
    }

    const formattedBody = chunks.reverse().join('.');
    return `${formattedBody}-${dv}`;
  }
}